import React from "react";
import {
  Alert,
  Button,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ProductImageViewer from "../../../routes/pricing-reports/ProductImageViewer";

const MissingRecordModal = ({
  open,
  title,
  record,
  taskRun,
  actionLoading,
  error,
  children,
  onClose,
  onResolve,
  onSkip,
  onReject,
  resolveDisabled = false,
  skipDisabled = false,
}) => {
  const status = record?.status || "pending";

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ pr: 7 }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="h6">{title}</Typography>
          <Chip size="small" label={status} />
        </Stack>
        <IconButton
          aria-label="close"
          onClick={onClose}
          disabled={actionLoading}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          {error ? <Alert severity="error">{error}</Alert> : null}
          {taskRun?.sourceImageUrl ? (
            <ProductImageViewer src={taskRun.sourceImageUrl} alt={`${title} source`} maxHeight={240} />
          ) : null}

          {children}
        </Stack>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: "center",
          py: 2,
          px: 3,
          gap: 2,
        }}
      >
        <Button
          color="error"
          variant="outlined"
          size="large"
          onClick={onReject}
          disabled={actionLoading || status === "rejected"}
          sx={{ minWidth: 160 }}
        >
          Reject
        </Button>
        <Button
          variant="outlined"
          size="large"
          onClick={onSkip}
          disabled={actionLoading || skipDisabled}
          sx={{ minWidth: 160 }}
        >
          Skip
        </Button>
        <Button
          variant="contained"
          size="large"
          onClick={onResolve}
          disabled={
            actionLoading ||
            status === "resolved" ||
            status === "auto_resolved" ||
            resolveDisabled
          }
          sx={{ minWidth: 200 }}
        >
          Resolve
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MissingRecordModal;
